import Section from '../ui/Section/Section'
import Reveal from '../ui/Reveal/Reveal'
import Tag from '../ui/Tag/Tag'
import { skills } from '../../data/portfolio'
import styles from './Skills.module.css'

const Skills = ({ index }) => {
  if (!skills.length) return null

  return (
    <Section
      id="skills"
      index={index}
      title="Skills & tools"
      eyebrow="Skills"
      lead="The stack I reach for, grouped by where it fits."
    >
      <div className={styles.grid}>
        {skills.map((group, position) => (
          <Reveal key={group.id} delay={position * 70} className={styles.group}>
            <h3 className={styles.groupTitle}>
              <span className={styles.groupIndex} aria-hidden="true">
                {String(position + 1).padStart(2, '0')}
              </span>
              {group.title}
            </h3>

            <ul className={styles.items}>
              {group.items.map((item) => (
                <Tag key={item}>{item}</Tag>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </Section>
  )
}

export default Skills
